import React from 'react';
import GenericSelect from '../../../../../components/common/GenericSelect';
import { coreTypes } from 'dealer-website-components';
import { includes } from 'lodash';

const BodiesFilter = ({ filterData, filterValues, filterAdd, filterDelete }) => {
  const { FilterTypes } = coreTypes;
  const handleChange = (data) => {
    if (includes(filterValues, data.value)) {
      filterDelete(FilterTypes.body, data.value);
    } else {
      filterAdd(FilterTypes.body, data.value);
    }
  };

  return (
    <React.Fragment>
      <div className='builder-font-semibold builder-mb-2 builder-mt-5'>Body type</div>
      <GenericSelect placeHolder='All' items={filterData} values={filterValues} handleFilterChanged={handleChange} />
    </React.Fragment>
  );
};

export default BodiesFilter;
